var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advertisement"},[_c('div',{staticClass:"advertisement-header"},[_c('div',{staticClass:"advertisement-header-text"},[_c('h3',[_vm._v("数字内容制作")]),_c('p',[_vm._v("致力于创造优质、引人入胜的数字内容，为客户提供创意和影响力。")]),_c('div',{on:{"click":_vm.handleClick}},[_vm._v("发布信息")])])]),_c('common',{attrs:{"type":"3"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }